/**
 * Toggle the "[GANTT-PERF DEBUG]" console instrumentation (schedule fetch,
 * ScenarioGanttWrapper merges, ScenarioGantt load/refresh) on by setting
 * localStorage.setItem('gantt-perf-debug', '1') and reloading. Off by
 * default so the logs don't clutter the console for regular use.
 */
export function isGanttPerfDebugEnabled() {
  try {
    return localStorage.getItem("gantt-perf-debug") === "1";
  } catch {
    return false;
  }
}

const MS_PER_YEAR = 365.25 * 24 * 60 * 60 * 1000;

const asDate = (value) => {
  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }
  if (value === null || value === undefined || value === "") return null;
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
};

// toISOString throws past ±275760 and pads years oddly outside 0..9999, which
// is exactly the range a runaway bound lands in — the case worth reading.
const day = (date) => {
  const year = date.getFullYear();
  if (year < 0 || year > 9999) return `year ${year}`;
  return date.toISOString().slice(0, 10);
};

/**
 * Renders a date range as `2024-01-01->2026-12-31 (3y)`.
 *
 * The scheduling engine builds its calendar caches across the project's whole
 * range, so a bound centuries out costs seconds no matter how few activities
 * there are. Printed next to the row counts, it separates "too much data" from
 * "too wide a span" without having to guess between them.
 */
export function describeDateSpan(start, end) {
  const from = asDate(start);
  const to = asDate(end);
  const years =
    from && to ? `${Math.round((to.getTime() - from.getTime()) / MS_PER_YEAR)}y` : "?";
  return `${from ? day(from) : "none"}->${to ? day(to) : "none"} (${years})`;
}
